<template>
  <button v-if="!to && !url" :class="classes" :disabled="loading">
    <slot></slot>
  </button>
  <router-link v-else-if="to" :class="classes" :to="to" :target="target"
    ><slot></slot
  ></router-link>
  <a v-else :class="classes" :href="url" :target="target"><slot></slot></a>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    narrow: Boolean,
    to: [Boolean, Object],
    url: [Boolean, String],
    outline: Boolean,
    target: [Boolean, String],
    background: [Boolean, String],
    centerText: Boolean,
  },
  computed: {
    classes() {
      let classes = ["button"];
      if (this.loading) {
        classes.push("-loading");
      }
      if (this.narrow) {
        classes.push("-narrow");
      }
      if (this.url) {
        classes.push("-link");
      }
      if (this.centerText) {
        classes.push("-center-text");
      }
      if (this.background) {
        classes.push("-" + this.background);
      }
      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.button {
  font: 600 16px/1 CenturyGothic;
  color: #fff;
  display: inline-flex;
  text-decoration: none;
  justify-content: space-between;
  text-transform: uppercase;
  background-color: #00205b;
  padding: 16px;
  box-shadow: 0 2px 4px #00205b;
  &.-turquoise {
    background-color: #a9c47f;
    box-shadow: 0 2px 4px #a9c47f;
    color: #00205b;
  }
  &:after {
    content: "";
    display: inline-block;
    background-image: url("~@/assets/images/arrow.svg");
    height: 1em;
    width: 1em;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  &:disabled {
    background-color: rgba(#00205b, 0.6);
  }
  &.-loading {
    &:after {
      background-image: url("~@/assets/images/spinner.svg");
      animation: spin 0.5s linear infinite;
      @keyframes spin {
        from {
          transform: rotate(0);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
  &.-narrow {
    padding: 9px 16px;
  }
  &.-link {
    &:after {
      content: none;
    }
  }
  &.-outline {
    background-color: transparent;
    color: #00205b;
    border: 1px solid #00205b;
    box-shadow: none;
  }
  &.-background {
    background-color: #fff;
  }
  &.-center-text {
    justify-content: center;
  }
}
</style>
